module.exports = {"defaultLocale":"en-gb","fallbackLocale":"en","defaultNumericLocale":"en","displayNegativesInParentheses":true}